module.exports = __webpack_public_path__ + "static/student-exeperience-5098e2163d715cf15e5175ecaa2b2f0c.png";